import { AxiosInstance } from 'axios';
import { toast } from 'react-toastify';

import API from '.';
import { store } from 'src/services/store';
import { userLogout } from 'src/services/user/actionCreators';
import { retrieveUser } from '../storage/user';

let toastOpen = false;
let isRefreshing = false;
let refreshSubscribers: any[] = [];

const logout = () => {
  if (!toastOpen) {
    toastOpen = true;
    toast.error('Session terminated. Please log in again.', {
      onClose() {
        toastOpen = false;
      },
    });
  }
  store.dispatch(userLogout() as any);
};

function subscribedRefresh(originalRequest: any, instance: AxiosInstance) {
  return new Promise(resolve => {
    refreshSubscribers.push((token: string) => {
      originalRequest.headers.Authorization = `Bearer ${token}`;
      resolve(instance.request(originalRequest));
    });
  });
}

function callSubscribers(token: string) {
  refreshSubscribers.map(cb => cb(token));
}

export function createAuthRefreshInterceptor(instance: AxiosInstance) {
  let storedUser = retrieveUser();

  if (storedUser) {
    instance.defaults.headers.common.Authorization = `Bearer ${storedUser.token}`;
  }

  instance.interceptors.response.use(
    response => response,
    async error => {
      const { config, response } = error;
      const originalRequest = config;

      storedUser = retrieveUser();

      if (!(response && response.status === 401)) {
        return Promise.reject(error);
      }
      if (!storedUser) {
        logout();
        return;
      }
      const request = subscribedRefresh(originalRequest, instance);

      if (isRefreshing) {
        return request;
      }
      isRefreshing = true;
      const tokens = await API.USER.refreshToken(storedUser.refreshToken);
      isRefreshing = false;

      if (!tokens) {
        logout();
        return;
      }
      storedUser.token = tokens.token;
      storedUser.refreshToken = tokens.refreshToken;
      callSubscribers(storedUser.token);
      refreshSubscribers = [];
      instance.defaults.headers.common.Authorization = `Bearer ${storedUser.token}`;

      return request;
    }
  );
  return instance;
}



// WEBPACK FOOTER //
// ./src/services/api/apiAuthRefresh.ts